export default "__VITE_ASSET__bebf9373__"